var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 3L12.5182 2.4579L12.0457 2.00616L11.5337 2.41253L11.9999 3ZM11.9999 20.5L11.4042 20.9556L11.9919 21.7242L12.5897 20.9634L11.9999 20.5ZM11.5337 2.41253C11.0961 2.75981 10.4705 3.55084 9.88332 4.60914C9.28273 5.69169 8.68417 7.12179 8.34171 8.79809C7.65263 12.1711 8.00867 16.5151 11.4042 20.9556L12.5957 20.0444C9.4915 15.9849 9.19952 12.0932 9.81136 9.09833C10.1194 7.59071 10.6585 6.30385 11.195 5.33684C11.7449 4.34559 12.2558 3.75447 12.4662 3.58747L11.5337 2.41253ZM3 12.75L21 12.75V11.25L3 11.25L3 12.75ZM11.4817 3.5421C14.4498 6.37989 16.6551 13.3612 11.4102 20.0366L12.5897 20.9634C18.3447 13.6388 16.0051 5.79154 12.5182 2.4579L11.4817 3.5421Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEarth);
export default __webpack_public_path__ + "static/media/ico-earth.a9beacc09851ed35b156a985be012241.svg";
export { ForwardRef as ReactComponent };